docEmail.classy.controller({
    name: 'DocEmailController',
    inject: ['$scope', '$modal', 'DocumentsModelService', '$rootScope', 'SchoolTaxModelService', 'SchoolModelService', 'DateService', 'authServiceFactory'],
    init: function()
    {
        this.$.authServiceFactory = this.authServiceFactory;
        this.$.items = this.DocumentsModelService.get();
        this.$.schoolinfo = this.SchoolModelService.get()[0];
        this.$.taxinfo = this.SchoolTaxModelService.get()[0];
        this.$.separate(this.$.schoolinfo.taxDocuments);
        this.$.currentYear = this.DateService.getCurrentYear();
        this.$.requestPref = this.$.schoolinfo.requestPref;

        this.$.yearPref = '';
        if (this.$.taxinfo.currentYearAsk==1)
            this.$.yearPref += this.$.currentYear-1
        else if (this.$.taxinfo.previousYearAsk==1 && this.$.taxinfo.currentYearAsk==0)
            this.$.yearPref += this.$.currentYear-2;

        if (this.$.taxinfo.currentYearAsk==1 && this.$.taxinfo.previousYearAsk==1 && this.$.taxinfo.currentYearVer==1 && this.$.taxinfo.previousYearVer==1) {
            this.$.yearPref += " OR ";
            this.$.yearPref += this.$.currentYear-2
        }
        else if (this.$.taxinfo.currentYearAsk==1 && this.$.taxinfo.previousYearAsk==1 && (this.$.taxinfo.currentYearVer==1 || this.$.taxinfo.previousYearVer==1)) {
            this.$.yearPref += " & ";
            this.$.yearPref += this.$.currentYear-2
        }
    },
    separate: function(doc) 
    {

        this.$.documentarray = [];
        let sNumber = doc.toString();

        for (var i=0, len=sNumber.length; i < len; i += 1) {
            this.$.documentarray.push(+sNumber.charAt(i)); 
        }

    }
});

